/* Optional shopping timer only. Never reserves stock, changes prices, or limits checkout. */
(function () {
  'use strict';
  var key = 'pickie-shopping-timer-v1';
  var duration = 10 * 60 * 1000;
  var record = null;
  var hasItems = false;
  var itemCount = 0;
  var interval = null;
  var storageAvailable = true;
  function read() {
    try {
      var value = JSON.parse(window.localStorage.getItem(key));
      return value && Number.isSafeInteger(value.startedAt) && Number.isSafeInteger(value.expiresAt) && value.expiresAt - value.startedAt === duration ? value : null;
    } catch (_) { storageAvailable = false; return null; }
  }
  function render() {
    var node = document.querySelector('[data-shopping-timer]');
    if (!node) return;
    node.hidden = !hasItems || !record || !storageAvailable;
    if (node.hidden) return;
    var seconds = Math.max(0, Math.min(600, Math.ceil((record.expiresAt - Date.now()) / 1000)));
    var time = node.querySelector('[data-shopping-timer-value]');
    if (time) time.textContent = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
    var note = node.querySelector('[data-shopping-timer-note]');
    if (note) {
      var showActiveNote = itemCount > 0 && itemCount < 1000;
      note.hidden = seconds > 0 && !showActiveNote;
      note.textContent = seconds ? (showActiveNote ? node.dataset.activeNote : '') : node.dataset.expiredNote;
    }
    node.dataset.expired = String(seconds === 0);
    if (!seconds && interval) { clearInterval(interval); interval = null; }
  }
  function schedule() {
    if (interval) { clearInterval(interval); interval = null; }
    render();
    if (hasItems && record && storageAvailable && record.expiresAt > Date.now()) interval = setInterval(render, 1000);
  }
  window.PICKIE_MINIMAL_TIMER = {
    sync: function (cart, allowStart) {
      if (!cart || !Number.isSafeInteger(cart.item_count)) return;
      itemCount = cart.item_count;
      hasItems = itemCount > 0;
      record = read();
      if (!hasItems) {
        record = null;
        try { window.localStorage.removeItem(key); } catch (_) { storageAvailable = false; }
      } else if (!record && allowStart && storageAvailable) {
        var now = Date.now();
        record = { startedAt: now, expiresAt: now + duration };
        try { window.localStorage.setItem(key, JSON.stringify(record)); } catch (_) { storageAvailable = false; record = null; }
      }
      schedule();
    }
  };
  window.addEventListener('storage', function (event) {
    if (event.key !== key && event.key !== null) return;
    record = read(); schedule();
  });
  function resume() { record = read(); schedule(); }
  window.addEventListener('pageshow', resume);
  window.addEventListener('focus', resume);
  document.addEventListener('visibilitychange', resume);
})();
